import { render } from "./AdicionarVariavel.vue?vue&type=template&id=7ebfbe79&ts=true"
import script from "./AdicionarVariavel.vue?vue&type=script&lang=ts"
export * from "./AdicionarVariavel.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__